export default {
  locale: "en",
  name: "Excluded stay dates",
  translation: { displayName: "Translations" },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
      },
    ],
    form: [
      {
        fieldName: "startDate",
        displayName: "Start Date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsStart: true,
        className: "tickerInput closeButtonInside",
      },
      {
        fieldName: "endDate",
        displayName: "End Date",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Enter a date",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsEnd: true,
        className: "tickerInput closeButtonInside",
      },
    ],
  },
};
